import './App.css';
import { ThemeProvider } from '@material-ui/styles';
import UItheme from "@bamboobox/b2-theme";
import { useAuthState } from "@bamboobox/b2logincheck";
import { HashRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import React, { useState } from 'react';
import { version } from '../package.json';
// import { useClearCache } from 'react-clear-cache';
// import CacheBuster from 'react-cache-buster';
import ManualObjectStart from './ManualObjectStart';
import ManualObjectStartOld from './src-old/ManualObjectStart';
import { useEffect } from 'react';

function App() {
  const userDetails = useAuthState();
  const tenantId = userDetails.user.tenantId;
  const [isLoading, setIsLoading] = useState(true);
  const [isNew, setIsNew] = useState(false);

  const getManualUploadScreenAccess = async () => {
    try {
        const options = {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                tenantId: tenantId,
                tool: "manual-upload",
                keys: ["manual-upload"],
            }),
        };
        const config = await fetch(`${window._env_.TENANT_CONFIG}/tenant/get-tenant-config`, options);
        const configData = await config.json();
        console.log("configData", configData);
        if(configData.length > 0 && configData[0]) {
            setIsNew(configData[0]?.configVal === "new");
        }
    } catch(e) {
        console.error("Error in getManualUploadScreenAccess", e);
    } finally {
        setIsLoading(false);
    }
  }
  useEffect(() => {
    getManualUploadScreenAccess();
  }, [])

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div className="loader" />
      </div>
    );
  }

  return (
      <React.Fragment>
              
    <div className="App">
        {/* <AuthProvider loginURL={window._env_.LOGIN_URL} authcheckURL={window._env_.AUTH_URL}> */}
            {/* <ThemeProvider theme={UItheme}> */}
      
                {isNew ? 
                    <Routes>
                        <Route exact path="/" element={<ManualObjectStart/>}></Route>
                    </Routes>
                    :
                    <Routes>
                        <Route exact path="/" element={<ManualObjectStartOld/>}></Route>
                    </Routes>
                }
    
                
            {/* </ThemeProvider> */}
        {/* </AuthProvider> */}
    </div>
    </React.Fragment>
);
}

export default App;
